// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ChoiceContext, GetChoiceContextRequest } from '@digitalasset/allocation-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Allocation } from '@daml.js/splice-api-token-allocation/lib/Splice/Api/Token/AllocationV1';
import { ContractId } from '@daml/types';
import { useAllocationApiClient } from '../../../contexts/AllocationApiContext';

export const useAllocationWithdrawContext: () => UseMutationResult<
  ChoiceContext,
  string,
  {
    registrar: string;
    allocationCid: ContractId<Allocation>;
  }
> = () => {
  const allocationApi = useAllocationApiClient();
  const getChoiceContextRequest: GetChoiceContextRequest = { meta: {} };

  return useMutation({
    mutationKey: ['allocationWithdrawContext', allocationApi],
    mutationFn: async ({ registrar, allocationCid }) => {
      return allocationApi.getAllocationWithdrawContext(
        allocationCid,
        registrar,
        getChoiceContextRequest,
      );
    },
    retry: false,
  });
};
